module.exports = __webpack_public_path__ + "static/media/0023.7c6b7858.svg";